<div class="create-ouvrage-page">
  <div class="flex justify-content-between align-items-center mb-3">
    <h2 class="page-title m-0">Créer un projet</h2>
    <app-bulk-create-ouvrage *ngIf="isSuperCem" (ouvragesCreated)="loadData()"></app-bulk-create-ouvrage>
  </div>

  <p-card styleClass="shadow-none">
    <app-filters [filters]="filters"
                 [defaultValues]="{Support: ['LIVRES', 'CONSO']}"
                 (onFilterChange)="loadData()"></app-filters>

    <ng-container *ngIf="this.dataLoaded">
      <p-table [value]="articles"
               [paginator]="true"
               [rows]="25"
               class="mt-3"
               [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Titre Web</th>
            <th>EAN</th>
            <th>Code Article</th>
            <th>Titre de la collection</th>
            <th>Assistant d'edition</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body"
                     let-article>
          <tr>
            <td>{{ article.TitreWEB }}</td>
            <td>{{ article.EAN }}</td>
            <td>{{ article.CodeArticle }}</td>
            <td>{{ article.NomCollection }}</td>
            <td>{{ article.AssistantEditoFormated }}</td>
            <td>
              <div class="flex gap-2">
                <ng-container *ngIf="article.ouvrage.length==0">
                  <button pButton
                          icon="pi pi-pencil"
                          [disabled]="isDegradedMod"
                          (click)="displayFormCreation(article.id)">&nbsp;Création du code projet
                  </button>
                </ng-container>
                <ng-container *ngIf="article.ouvrage.length>0">
                  <ng-container *ngFor="let o of article.ouvrage;">
                    <button pButton
                            class="p-button-info"
                            icon="pi pi-external-link"
                            [disabled]="isDegradedMod"
                            (click)="goToRessourcesNumeriques(o.id)">&nbsp;Ouvrir le projet
                    </button>
                  </ng-container>
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
  </p-card>

  <p-dialog header="Création du code projet"
            [modal]="true"
            [(visible)]="displayForm"
            [style]="{width: '30vw'}">
    <form name="form"
          [formGroup]="ouvrageForm"
          (ngSubmit)="onSubmitOuvrageForm()">
      <input type="hidden"
             name="id"
             id="id"
             formControlName="id">

      <div class="field grid align-items-center">
        <label for="CodeProjet"
               class="col-12 md:col-4">Code projet</label>
        <div class="col-12 md:col-8">
          <input type="text"
                 name="CodeProjet"
                 id="CodeProjet"
                 formControlName="CodeProjet"
                 pInputText
                 class="w-full">
        </div>
      </div>

      <div class="field grid align-items-center">
        <label for="ouvrageReforme"
               class="col-12 md:col-4">Ouvrage réforme</label>
        <div class="col-12 md:col-8">
          <input type="checkbox"
                 name="ouvrageReforme"
                 id="ouvrageReforme"
                 formControlName="OuvrageReforme">
        </div>
      </div>

      <div *ngIf="submitted && ouvrageForm.controls['CodeProjet'].invalid"
           class="alert alert-danger mb-3">
        <div *ngIf="ouvrageForm.controls['CodeProjet'].errors?.['required']">
          Le code projet est obligatoire
        </div>
      </div>

      <div class="flex justify-content-end">
        <button type="submit"
                label="Valider"
                [disabled]="isDegradedMod"
                pButton></button>
      </div>

      <div *ngFor="let error of errors" class="mt-2">
        <p-message severity="error" text="{{error}}"></p-message>
      </div>
      <div *ngIf="successMessage != ''" class="mt-2">
        <p-message severity="success" text="{{successMessage}}"></p-message>
      </div>
    </form>
  </p-dialog>
</div>
